import React from 'react';
import { cn } from '@/lib/utils';

interface SectionHeaderProps {
  id?: string;
  eyebrow?: string;
  title: React.ReactNode;
  children?: React.ReactNode;
  align?: 'left' | 'center';
  as?: 'h1' | 'h2';
  className?: string;
}

const SectionHeader = ({
  id,
  eyebrow,
  title,
  children,
  align = 'left',
  as: Heading = 'h2',
  className,
}: SectionHeaderProps) => (
  <div className={cn('reveal max-w-3xl', align === 'center' && 'mx-auto text-center', className)}>
    {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
    <Heading
      id={id}
      className={cn(
        Heading === 'h1' ? 'text-5xl sm:text-6xl lg:text-7xl' : 'text-4xl sm:text-5xl lg:text-[4.25rem]',
        'mb-6 leading-[1.02]',
      )}
    >
      {title}
    </Heading>
    {children && <div className="body-copy space-y-4">{children}</div>}
  </div>
);

export default SectionHeader;
